import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { IDistrict, IDistrictForm } from 'src/models/district.model';
import { useDistrictContext } from 'src/contexts/district.context';
import Lang from 'src/libraries/language';
import { getDistrictStatus } from 'src/selectors/district.selector';
import { actionTypes } from 'src/ducks/district.duck';
import DistrictForm from '../district-form/district-form.component';
import style from '../district-list/district-list.module.scss';

type IProp = {
  data: IDistrict;
};

const DistrictEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useDistrictContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [company, setCompany] = useState(data.relationship);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IDistrictForm> = {
    key: data.key,
    value: data.value,
    relationship: data.relationship,
  };

  const editStatus = getDistrictStatus(state, actionTypes.DISTRICT_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (formData) => {
      // key can be number or undefined
      if (!(data.key === undefined)) {
        const response = await actions.updatePUT(data.key, formData);

        if (!response.error) {
          ToastSuccess(
            Lang.formatString(Lang.MSG_DISTRICT_EDIT_SUCCESS, data.value)
          );
        } else {
          ToastError(response.error.message);
        }

        setIsEditOpen(false);
        actions.listGET();
      }
    },
    [data, actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_MODIFY_DISTRICT}
      content={
        <div className={style.content}>
          <DistrictForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
            company={setCompany}
            companyName={company}
            editIsOpen={isEditOpen}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default DistrictEdit;
